// Daily crawl totals per retailer for Admin → Retailer health, summarized by the
// server from the store-analytics snapshots (one file per retailer per day).

import FetchClient, { type ApiResponse } from "./FetchClient";

export interface RetailerTrendDay {
  date: string; // YYYY-MM-DD, Eastern calendar day
  available: boolean; // false = no snapshot for the day
  users: number;
  storesWithUsers: number;
  storesCrawled: number;
  products: number;
}

export interface RetailerTrend {
  retailer: string;
  name: string;
  days: RetailerTrendDay[];
}

export interface RetailerTrendsData {
  days: number;
  fromDate: string;
  throughDate: string;
  generatedAt: number;
  retailers: RetailerTrend[];
}

export async function getRetailerTrends(days: number): Promise<RetailerTrendsData> {
  const response = await FetchClient.get<ApiResponse<RetailerTrendsData>>(`/admin/retailer-trends?days=${days}`);
  if (!response?.data) throw new Error("Retailer trends returned no data");
  return response.data;
}
